import React from 'react';
import TitlePage from '../../components/general/TitlePage/TitlePage';
import Faq from '../../components/extern/Faq/Faq';
import { Helmet } from 'react-helmet';

const FaqPage = () => {
    return (
        <main>
            <TitlePage
                title="Central de Perguntas Frequentes"
                subtitle="Encontre respostas rápidas e confiáveis para as principais dúvidas."
            />

            <Helmet>
                <title>FAQ</title>
            </Helmet>
            
            <Faq />
        </main>
    );
};

export default FaqPage;